import { useCallback, useContext, useMemo } from 'react';
import { useShallow } from 'zustand/shallow';
import { AchievementModal } from '~/components/achievement/AchievementModal';
import { ModalContext } from '~/context/ModalContext';
import { userGetters } from '~/recoil/user';
import { useAchievementStore } from '~/stores';

const EMPTY_ACHIEVEMENTS: never[] = [];

export const useAchievementModal = () => {
  const user = userGetters.useValue();
  const userId = user.selected_child_id;
  const achievements = useAchievementStore(
    useShallow((s) => s.achievements[userId] ?? EMPTY_ACHIEVEMENTS),
  );
  const { openModal } = useContext(ModalContext);

  // アチーブメントモーダルが表示可能な状態か判定する
  const canOpenAchievementModal = useMemo(() => {
    return achievements.length !== 0;
  }, [achievements]);

  const openAchievementModal = useCallback(() => {
    if (achievements.length === 0) return;
    openModal(() => AchievementModal({ id: userId, achievementType: achievements[0] }));
  }, [achievements, userId, openModal]);

  return {
    canOpenAchievementModal,
    openAchievementModal,
  };
};
